<template>
  <div
    class="arrow-circle"
    :class="`${props.direction ? props.direction : ''}${props.color ? ` ${props.color}` : ''}`">
    <div class="circle-container">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 36 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.03641 26.2752L18.1457 35.3845L18.1216 26.1103L18.133 30.4523C18.1377 32.2293 15.9957 33.1294 14.7296 31.8825L9.03641 26.2752Z"
          fill="#0E242D" />
        <path
          d="M18.1457 35.3845L24.2185 29.3116L27.255 26.2752L21.5422 31.9467C20.282 33.1979 18.1378 32.3084 18.1331 30.5327L18.1216 26.1103L18.1457 35.3845Z"
          fill="#0E242D" />
        <path
          d="M18.1216 1L18.1216 26.1103M18.1457 35.3845L24.2185 29.3116L27.255 26.2752M18.1457 35.3845L9.03641 26.2752M18.1457 35.3845L18.1216 26.1103M30.2914 23.2388L27.255 26.2752M5.99999 23.2388L9.03641 26.2752M27.255 26.2752L21.5422 31.9467C20.282 33.1979 18.1378 32.3084 18.1331 30.5327L18.1216 26.1103M9.03641 26.2752L14.7296 31.8825C15.9957 33.1294 18.1377 32.2293 18.133 30.4523L18.1216 26.1103"
          stroke="#0A2238"
          :stroke-width="strokeWidth"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  direction: { type: String, default: '' },
  color: { type: String, default: '' },
  strokeWidth: { type: Number, default: 2 },
})
</script>

<style lang="scss">
.arrow-circle {
  @apply cursor-pointer overflow-hidden rounded-full border border-bicara-dark-blue;

  .circle-container {
    @apply relative overflow-hidden p-5 transition-transform lg:p-6;

    &:after {
      @apply absolute bottom-0 left-0 right-0 top-0 -z-1 origin-center scale-75 rounded-full bg-bicara-yellow transition-transform content-[''];
    }
  }

  &:hover {
    .circle-container {
      &:after {
        @apply scale-100;
      }
    }
  }

  &.blue {
    .circle-container {
      &:after {
        @apply bg-bicara-turquoise;
      }
    }
  }

  &.dark-blue {
    @apply border-white;

    .circle-container {
      svg {
        path {
          @apply stroke-white;
        }
      }

      &:after {
        @apply bg-bicara-blue;
      }
    }
  }

  &.right {
    .circle-container {
      @apply rotate-[270deg];
    }
  }

  &.up {
    .circle-container {
      @apply rotate-180;
    }
  }

  &.left {
    .circle-container {
      @apply rotate-90;
    }
  }
}
</style>
